import { render, staticRenderFns } from "./Breed.vue?vue&type=template&id=14b24a2a&scoped=true&"
import script from "./Breed.vue?vue&type=script&lang=js&"
export * from "./Breed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b24a2a",
  null
  
)

export default component.exports